import './orders'

import { isApp } from '~/js/helpers/user-agent-helper'
import { getUrlWithQueryParams, getParam } from '~/js/helpers/url-helper'

const ID_CUSTOMERS_ACCOUNT = 'js-customers-account'
const ID_CUSTOMERS_ACCOUNT_LOADING = 'js-customers-account-loading'

if (getParam('hbSubscriptionPath') && getParam('view') !== 'teikibin') {
  window.location = getUrlWithQueryParams({ view: 'teikibin' })
}

document.addEventListener('DOMContentLoaded', () => {
  const elementCustomersAccount = document.getElementById(ID_CUSTOMERS_ACCOUNT)
  if (!elementCustomersAccount) return
  if (isApp()) return
  elementCustomersAccount.style.display = null
  document.getElementById(ID_CUSTOMERS_ACCOUNT_LOADING).remove()
})
